import { ArrowDown, ArrowLeft, ArrowRight, ArrowUp } from 'lucide-react'
import { DEFAULT_WRAP_OFFSET_PT } from '@/lib/object-effects/text-wrap'
import type { OffsetKey, OffsetStrings } from '../types/wrap-offset'

// Order matches AC 4.5's required tooltip order (top, right, bottom, left) — also drives the
// on-screen grid order below.
export const OFFSET_SIDES = [
  {
    key: 'top' as const,
    field: 'wrapOffsetTop' as const,
    Icon: ArrowUp,
    label: 'Top Offset',
    tooltip: 'Offset top',
  },
  {
    key: 'right' as const,
    field: 'wrapOffsetRight' as const,
    Icon: ArrowRight,
    label: 'Right Offset',
    tooltip: 'Offset right',
  },
  {
    key: 'bottom' as const,
    field: 'wrapOffsetBottom' as const,
    Icon: ArrowDown,
    label: 'Bottom Offset',
    tooltip: 'Offset bottom',
  },
  {
    key: 'left' as const,
    field: 'wrapOffsetLeft' as const,
    Icon: ArrowLeft,
    label: 'Left Offset',
    tooltip: 'Offset left',
  },
]

export const OFFSET_MIN = 0
export const OFFSET_MAX = 500

export const COMMON_OFFSET_PRESETS = [0, 3, 6, 9, 12] as const
export const COMMON_OFFSET_SLIDER_MIN = 0
export const COMMON_OFFSET_SLIDER_MAX = 500
/** Default offset (pt) for every wrap style when a target has no stored value yet — matches the
 *  6pt preset so a freshly wrapped object starts with that preset highlighted. Same constant the
 *  wrap geometry (`compute-wrap-obstacles.ts`) defaults an unset side to, so the panel never
 *  displays a number the actual layout doesn't honor. */
export const DEFAULT_OFFSET = DEFAULT_WRAP_OFFSET_PT
export const DEFAULT_OFFSET_STRINGS: OffsetStrings = {
  top: String(DEFAULT_OFFSET),
  right: String(DEFAULT_OFFSET),
  bottom: String(DEFAULT_OFFSET),
  left: String(DEFAULT_OFFSET),
}
export const ALL_SIDES_UNMIXED: Record<OffsetKey, boolean> = {
  top: false,
  right: false,
  bottom: false,
  left: false,
}
/** Empty string = valid, for every side. */
export const NO_OFFSET_ERRORS: Record<OffsetKey, string> = {
  top: '',
  right: '',
  bottom: '',
  left: '',
}
